import React, { useState } from 'react';
import CommEmailPanel from './CommEmailPanel';
import './CommunicationsHubModal.css';

const TABS = [
  { id: 'email', label: 'Email' },
  { id: 'voice', label: 'Voice Calls' },
  { id: 'messaging', label: 'Messaging' },
];

/**
 * Hub modal for Communications agents (Gmail + Optimail PA). Opens from OPO AI Agents tab.
 */
const CommunicationsHubModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('email');

  if (!isOpen) return null;

  return (
    <div className="comm-hub-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="comm-hub-box" onClick={(e) => e.stopPropagation()}>
        <div className="comm-hub-header">
          <h2 className="comm-hub-title">Communications</h2>
          <button type="button" className="comm-hub-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="comm-hub-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`comm-hub-tab ${activeTab === tab.id ? 'comm-hub-tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="comm-hub-content">
          {activeTab === 'email' && <CommEmailPanel />}
          {activeTab === 'voice' && (
            <div className="comm-hub-placeholder">
              <p>Voice call agents will be built here.</p>
              <p className="comm-hub-placeholder-hint">
                Dedicated agents to route, summarize, and act on voice communications — coming later.
              </p>
            </div>
          )}
          {activeTab === 'messaging' && (
            <div className="comm-hub-placeholder">
              <p>Messaging agents will be built here.</p>
              <p className="comm-hub-placeholder-hint">
                SMS, chat, and other messaging channels — coming later.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommunicationsHubModal;
